/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * The copy content size.
 */
export enum CONTENT_BLOCK_COPY_SIZE {
  /**
   * Small size.
   */
  SMALL = 'sm',

  /**
   * Regular size, equals to the middle size.
   */
  REGULAR = 'md',
}

/**
 * The style scheme for the complementary content.
 */
export enum CONTENT_BLOCK_COMPLEMENTARY_STYLE_SCHEME {
  /**
   * Regular style.
   */
  REGULAR = 'regular',

  /**
   * A style with border.
   */
  WITH_BORDER = 'with-border',
}
